// Spinner — a small loading indicator. Pair with VisuallyHidden text
// so screen readers announce the loading state.

import { tokens } from "../tokens/tokens";

import { VisuallyHidden } from "./VisuallyHidden";

export interface SpinnerProps {
  /** Diameter in px. Default 20. */
  size?: number;
  /** Accessible label. Default "Loading". */
  label?: string;
}

export function Spinner({ size = 20, label = "Loading" }: SpinnerProps) {
  return (
    <>
      <span
        aria-hidden="true"
        style={{
          display: "inline-block",
          width: size,
          height: size,
          border: `2px solid ${tokens.color.neutral[300]}`,
          borderTopColor: tokens.color.brand[500],
          borderRadius: "50%",
          animation: "ds-spin 0.8s linear infinite",
        }}
      />
      <VisuallyHidden>{label}</VisuallyHidden>
      <style>{`@keyframes ds-spin { to { transform: rotate(360deg); } }`}</style>
    </>
  );
}
